<template>
  <span v-if="bucketRange[1] - bucketRange[0] < 100">
    <v-tooltip v-if="showWarning" bottom>
      <template #activator="{ props }">
        <v-icon v-bind="props" class="mr-1 !align-baseline" size="14" color="warning">
          fa:fas fa-exclamation-triangle
        </v-icon>
      </template>
      <span>
        This is in multiple segments, and will be shown to users of ANY of the segments.<br />
        We recommend experimenting between prompts in a single segment only,<br />
        or ensuring the segments are mutually exclusive.
      </span>
    </v-tooltip>

    <span class="text-xs font-bold">{{ bucketRange[1] - bucketRange[0] }}%</span>
    <RfSegmentBucketRangeBar
      class="ml-1 h-3 w-8 align-middle text-transparent"
      activeClass="bg-blue-50"
      inactiveClass="bg-background"
      :range="bucketRange"
    />
  </span>
</template>

<script setup>
import RfSegmentBucketRangeBar from "@/components/RfSegments/RfSegmentBucketRangeBar.vue";

defineProps(["bucketRange", "showWarning"]);
</script>
